export default __webpack_public_path__ + "static/media/80-ANNIVERSARY.ce00ecd8.png";